export class ListAllAction {
  public static readonly type = '[Project/Storage/List] ListAllAction';
  constructor(public readonly pageNumber?: number) {}
}
